module.exports = __webpack_public_path__ + "2becb720fe9ff3f53bfd66b20c763db1.pdf";